/*

live-feed og session-holde-åpner

*/
export class GlobalWindowPropertyHelper {
    static get(property, default_value) {
        let topWindow = this.getAccesibleTop();
        let val;
        let prevWindow = topWindow;
        let cnt = 0;
        do {
            try {
                val = this._getHelper(topWindow, property);
            }
            catch (_error) {
                val = undefined;
                topWindow = prevWindow;
                break;
            }
            if (val === undefined && window.opener) {
                if (topWindow.document.head.querySelector('link[rel="c:baseurl"]')) {
                    // Vi er i hovedframen i zoot, ikke klatre ut window.opener
                    break;
                }
                else if (topWindow.document.head.querySelector('meta[name="cerumx"][content="1"]')) {
                    // Vi er i hovedframen til cerumx, ikke klatre ut window.opener
                    break;
                }
                else {
                    prevWindow = topWindow;
                    topWindow = window.opener.top;
                }
            }
            else {
                break;
            }
            if (cnt++ > 10) {
                break;
            }
        } while (val === undefined);
        if (val === undefined && topWindow) {
            val = this._getHelper(topWindow, property, default_value);
        }
        if (val === undefined && default_value !== undefined) {
            throw new Error('Gikk meg vill');
        }
        return val;
    }
    static _getHelper(win, property, default_value) {
        let hash;
        if ('_glob_hash' in win) {
            hash = win._glob_hash;
            if (property in hash) {
                return hash[property];
            }
        }
        if (default_value !== undefined) {
            if (!hash) {
                hash = win._glob_hash = {};
            }
            hash[property] = default_value;
            return hash[property];
        }
        return undefined;
    }
    static getAccesibleTop() {
        try {
            if (top && top.document.location) {
                return top;
            }
        }
        catch (_error) {
            // void
        }
        let winPtr = window;
        let last;
        do {
            last = winPtr;
            try {
                winPtr = winPtr.parent;
                // This access to document is to trigger a security exception if we are in a cross-origin iframe
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                winPtr.document;
            }
            catch (_error) {
                return last;
            }
            last = winPtr;
        } while (last !== winPtr);
        return last;
    }
}
